import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  standalone: true,
  imports: [RouterLink],
  templateUrl: './feature-page.component.html',
  styleUrl: './feature-page.component.css'
})
export class FeaturePageComponent {
  private readonly route = inject(ActivatedRoute);
  readonly title = this.route.snapshot.data['title'] as string;
  readonly hu = this.route.snapshot.data['hu'] as string;
}
